import React from 'react';
import {connect} from 'react-redux'
import { Link, withRouter } from "react-router-dom"
import { dispatchItem, removeAllCache } from '../actions/actions'
import {hasAnyRoleExist, isSaglikBakanligi} from '../actions/utils';

class Header extends React.Component {
    constructor(props) {
        super(props);
    
        this.state = {
            mobileMenuIsOpen: false,
            isAdminPath: window.location.pathname === '/admin-login'
        };

        this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
        this.changeActivePopup = this.changeActivePopup.bind(this);
        this.logout = this.logout.bind(this);
    }

    changeActivePopup(activePopup) {
        this.props.dispatch(dispatchItem('POPUP', activePopup));
    }

    toggleMobileMenu() {
        if(this.state.mobileMenuIsOpen)
        {
            this.setState({
                mobileMenuIsOpen: false
            })
        }
        else {
            this.setState({
                mobileMenuIsOpen: true
            })
        }
    }
    
    logout() {
        localStorage.removeItem('user');
        localStorage.removeItem('userType');
        localStorage.removeItem('entryInfo');
        this.props.dispatch(removeAllCache());
        
        this.changeActivePopup('login');
    }

    render() {
        const isLoggedIn = this.props.app.accessToken !== "";
        const currentRoute = this.props.location.pathname;
        var isEntryCorporate = localStorage.getItem('entryInfo') === "Kurumsal";




        return (
            [
            <div className="header-placeholder"></div>,
            <header className={(this.state.mobileMenuIsOpen ? "menu-active" : "")}>
                <div className="container">
                    <div className="left">
                        <Link className="logo" to={"/"}>
                            <img src={require('../assets/icons/logo.svg')} alt="Vodafone Business Logo" width='100%' height='100%' />
                        </Link>
                    </div>
                    <div className="menu-wrapper">
                        {isLoggedIn && hasAnyRoleExist("Sales") &&
                            <div className="menu">
                                <Link id={"menu-company-list"} className={"vcenter" + (currentRoute.indexOf('/agent/company') >= 0 ? " active" : "")} to={"/agent/company/list"}>
                                    <span>
                                        Şirketler
                                    </span>
                                </Link>
                                <Link id={"menu-partner-list"} className={"vcenter" + (currentRoute.indexOf('/agent/partner') >= 0 ? " active" : "")} to={"/agent/partner/list"}>
                                    <span>
                                        Partnerler
                                    </span>
                                </Link>
                                <Link id={"menu-client-list"} className={"vcenter" + (currentRoute.indexOf('/agent/client') >= 0 ? " active" : "")} to={"/agent/client/list"}>
                                    <span>
                                        Müşteriler
                                    </span>
                                </Link>
                            </div>
                        }
                        {isLoggedIn && hasAnyRoleExist("Standart") &&
                            <div className="menu">
                                <Link id={"menu-groups"} className={"vcenter" + (currentRoute.indexOf('/user/group') >= 0 ? " active" : "")} to={"/user/group/list"}>
                                    <span>
                                        Gönderim Listeleri
                                    </span>
                                </Link>
                                <Link id={"menu-sendsms"} className={"vcenter" + (currentRoute.indexOf('/user/sendsms') >= 0 ? " active" : "")} to={"/user/sendsms"}>
                                    <span>
                                        SMS Gönder
                                    </span>
                                </Link>
                                <Link id={"menu-blackhour"} className={"vcenter" + (currentRoute.indexOf('/user/blackhour') >= 0 ? " active" : "")} to={"/user/blackhour"}>
                                    <span>
                                        Blackhour Ayarları
                                    </span>
                                </Link>
                                <Link id={"menu-blacklist"} className={"vcenter" + (currentRoute.indexOf('/user/blacklist') >= 0 ? " active" : "")} to={"/user/blacklist"}>
                                    <span>
                                        Karaliste Yönetimi
                                    </span>
                                </Link>
                                <Link id={"menu-report"} className={"vcenter" + (currentRoute.indexOf('/user/report') >= 0 ? " active" : "")} to={"/user/report"}>
                                    <span>
                                        Raporlar
                                    </span>
                                </Link>
                            </div>
                        }
                        {isLoggedIn && hasAnyRoleExist("Admin") &&
                            <div className="menu">
                                <Link id={"admin-user-list"} className={"vcenter" + (currentRoute.indexOf('/admin/user-list') >= 0 ? " active" : "")} to={"/admin/user-list"}>
                                    <span>
                                        Kullanıcı Listesi
                                    </span>
                                </Link>
                                <Link id={"admin-report-list"} className={"vcenter" + (currentRoute.indexOf('/admin/report-list') >= 0 ? " active" : "")} to={"/admin/report-list"}>
                                    <span>
                                        Gönderim Listesi
                                    </span>
                                </Link>
                            </div>
                        }
                        {isLoggedIn && hasAnyRoleExist("OmsgReport") && !isSaglikBakanligi() && isEntryCorporate &&
                            <div className="menu">
                                <Link id={"general-report"} className={"vcenter" + (currentRoute.indexOf('/omsg-report/general') >= 0 ? " active" : "")} to={"/omsg-report/general"}>
                                    <span>
                                        Genel Durum
                                    </span>
                                </Link>
                                <Link id={"daily-report"} className={"vcenter" + (currentRoute.indexOf('/omsg-report/daily') >= 0 ? " active" : "")} to={"/omsg-report/daily"}>
                                    <span>
                                        Günlük
                                    </span>
                                </Link>
                                <Link id={"invoice-report"} className={"vcenter" + (currentRoute.indexOf('/omsg-report/invoice') >= 0 ? " active" : "")} to={"/omsg-report/invoice"}>
                                    <span>
                                        Fatura Dönemi Bazlı
                                    </span>
                                </Link>
                                <Link id={"error-code-report"} className={"vcenter" + (currentRoute.indexOf('/omsg-report/error_code') >= 0 ? " active" : "")} to={"/omsg-report/error_code"}>
                                    <span>
                                        Hata Kodu Bazlı
                                    </span>
                                </Link>
                                <Link id={"error-code-msisdn-report"} className={"vcenter" + (currentRoute.indexOf('/omsg-report/error_msisdn_code') >= 0 ? " active" : "")} to={"/omsg-report/error_msisdn_code"}>
                                    <span>
                                        Hata Kodu Msisdn Bazlı
                                    </span>
                                </Link>
                        </div>
                        }
                        {isLoggedIn && hasAnyRoleExist("OmsgReport") && isSaglikBakanligi() &&
                            <div className="menu">
                                <Link id={"invoice-report"} className={"vcenter" + (currentRoute.indexOf('/omsg-report/invoice') >= 0 ? " active" : "")} to={"/omsg-report/invoice"}>
                                    <span>
                                        Fatura Dönemi Bazlı
                                    </span>
                                </Link>
                            </div>
                        }
                        {isLoggedIn && hasAnyRoleExist(["XIVodafone", "XIPartner", "XIConsultant","XIVFAdmin"]) &&
                            <div className="menu">
                                {(hasAnyRoleExist(["XIVodafone", "XIPartner","XIVFAdmin"])) &&
                                <Link id={"menu-xi-send"} className={"vcenter" + (currentRoute.indexOf('/xivodafone/client/list') >= 0 ? " active" : "")} to={"/xivodafone/client/list"}>
                                    <span>
                                        Gönderim Kur
                                    </span>
                                </Link>
                                 } 
                                 { hasAnyRoleExist(["XIVodafone", "XIPartner", "XIConsultant"]) &&
                                <Link id={"menu-xi-query"} className={"vcenter" + (currentRoute.indexOf('/xivodafone/query') >= 0 ? " active" : "")} to={"/xivodafone/query/list"}>
                                    <span>
                                        Sorgular
                                    </span>
                                </Link>}
                                {(hasAnyRoleExist(["XIVodafone", "XIPartner","XIVFAdmin"])) &&
                                <Link id={"menu-xi-draft"} className={"vcenter" + (currentRoute.indexOf('/xivodafone/draft/list') >= 0 ? " active" : "")} to={"/xivodafone/draft/list"}>
                                    <span>
                                        Taslaklar
                                    </span>
                                </Link>
                                 }
                                {(hasAnyRoleExist(["XIVodafone", "XIPartner"])) &&
                                <Link id={"menu-xi-report"} className={"vcenter" + (currentRoute.indexOf('/xivodafone/report') >= 0 ? " active" : "")} to={"/xivodafone/report"}>
                                    <span>
                                        Raporlar
                                    </span>
                                </Link>
                                }
                                {isLoggedIn && hasAnyRoleExist("XIVFAdmin") &&
                                        <Link id={"xiadmin-approve-list"} className={"vcenter" + (currentRoute.indexOf('/xivodafone/approve/list') >= 0 ? " active" : "")} to={"/xivodafone/approve/list"}>
                                            <span>
                                                Onay Listesi
                                            </span>
                                        </Link>
                                }         
                                {(hasAnyRoleExist(["XIVodafone", "XIConsultant"])) &&
                                    <Link id={"menu-xi-partnerreport"} className={"vcenter" + (currentRoute.indexOf('/xivodafone/partnerreport') >= 0 ? " active" : "")} to={"/xivodafone/partnerreport"}>
                                        <span>
                                           Gönderimler
                                        </span>
                                    </Link>
                                }

                            </div>
                        }
                     
                    </div>
                    <div className={"right" + (isLoggedIn ? " dropdown" : "")}>
                        {isLoggedIn &&
                            <div className="dropdown-container vcenter">
                                <span>{this.props.app.userEmail}</span>
                                <img className="icon-dropdown only-desktop" src={require('../assets/icons/icon-dropdown.svg')} aria-hidden="true" />
                                <img className="icon-user only-mobile" src={require('../assets/icons/icon-user.svg')} aria-hidden="true" width='100%' height='100%' />
                                <div className="dropdown-menu">
                                    {(hasAnyRoleExist("Standart")) &&
                                        <a id={"menu-changepassword"} href="javascript:void(0)" title="Şifremi Değiştir" onClick={() => this.changeActivePopup('updatePassword')}>Şifremi Değiştir</a>
                                    }
                                    <a id={"menu-logout"} href="javascript:void(0)" title="Çıkış Yap" onClick={() => this.logout()}>Çıkış Yap</a>
                                </div>
                            </div>
                        }
                        {!isLoggedIn && !this.state.isAdminPath &&
                            <a id={"menu-login"} className="login" href="javascript:void(0)" title="Giriş Yap" onClick={() => this.changeActivePopup('login')}>
                                <img src={require('../assets/icons/icon-user.svg')} aria-hidden="true" width='100%' height='100%' />
                                <span>Giriş Yap</span>
                            </a>
                        }
                        {!isLoggedIn && this.state.isAdminPath &&
                            <a id={"menu-login"} className="login" href="javascript:void(0)" title="Giriş Yap" onClick={() => this.changeActivePopup('adminLogin')}>
                                <img src={require('../assets/icons/icon-user.svg')} aria-hidden="true" width='100%' height='100%' />
                                <span>Giriş Yap</span>
                            </a>
                        }
                        {isLoggedIn && (hasAnyRoleExist("Standart")) &&
                            <a className="btn-mobile-menu only-mobile" href="javascript:void(0)" onClick={this.toggleMobileMenu}>
                                <img className="open" src={require('../assets/icons/icon-menu.svg')} aria-hidden="true" />
                                <img className="close" src={require('../assets/icons/icon-menu-close.svg')} aria-hidden="true" />
                            </a>
                        }

                    </div>
                </div>
            </header>
            ]
      );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app 
    }
}

export default withRouter(connect(mapStateToProps)(Header))